import { format } from 'date-fns'
import DOMPurify from 'dompurify'
import { useEffect, useState } from 'react'
import { isMobile } from 'react-device-detect'
import { useNavigate } from 'react-router-dom'
import { getInquiriesDetail } from '../../api/inquiries'
import { ReplyRounded } from '../../components/Badge'
import { BtnWhiteRounded } from '../../components/Button'
import MyShoppingSideBar from '../../components/myshopping/MyShoppingSideBar'
import { useAppContext } from '../../components/provider/AppProvider'
import { PageTitle } from '../../components/title/PageTitle'
import '../../css/myshopping.css'
import { AFWebLinkType, RNPostMessage } from '../../js/postMessage'

// 이미지 경로
const imgURL = '/images'

export default function InquiryView() {
  const [idParams, setIdParams] = useState<string>('')
  const [inquiryDetailData, setInquiryDetailData] = useState<any>(null)
  const [selectedImageSrc, setSelectedImageSrc] = useState<string | null>(null)
  const { isAppView } = useAppContext()
  const navigate = useNavigate()
  const queryString = window.location.search
  const urlParams = new URLSearchParams(queryString)
  const id = urlParams.get('id')

  const handleImageClick = (src: any) => {
    setSelectedImageSrc(src)
  }
  const togglePopup = () => {
    setSelectedImageSrc(null)
  }

  useEffect(() => {
    // 하단 fixed버튼이 있다면 푸터를 밀어내야함
    const footer = document.querySelector('.footer_wrap') as HTMLElement
    if (footer) {
      isMobile ? (footer.style.paddingBottom = '36px') : (footer.style.paddingBottom = '0')
    }
  }, [])

  useEffect(() => {
    if (id) setIdParams(id)
  }, [id])

  useEffect(() => {
    if (idParams !== '') {
      getInquiriesDetail({ inquiryNo: Number(idParams) }).then((res) => {
        setInquiryDetailData(res)
      })
    }
  }, [idParams])

  useEffect(() => {
    const dimPop = document.querySelector('.dim')
    const handleClickOutside = (event: any) => {
      if (dimPop) {
        if (dimPop.contains(event.target)) {
        }
      }
    }
    if (dimPop) {
      document.addEventListener('click', handleClickOutside)
    }
    return () => {
      document.removeEventListener('click', handleClickOutside)
    }
  })

  return (
    <>
      <div className='main_wrap'>
        <div className={isMobile ? 'contents_wrap' : 'contents_wrap sidemenu_wrap full'}>
          <MyShoppingSideBar />
          <div className='myshopping_wrap'>
            <PageTitle>1:1 문의</PageTitle>
            <hr />
            <div className='inquiry_view_wrap'>
              <div className='inquiry_view'>
                {/* 제목, 답변상태, 작성날짜 영역 */}
                <div className='title_wrap'>
                  <div className='part'>
                    {inquiryDetailData !== null && inquiryDetailData.data.inquiryType.inquiryTypeName}
                  </div>
                  <div className='title'>{inquiryDetailData !== null && inquiryDetailData.data.inquiryTitle}</div>
                  <div className='status_date'>
                    <ReplyRounded
                      isreply={
                        inquiryDetailData !== null && inquiryDetailData.data.inquiryStatus === 'ANSWERED'
                          ? 'true'
                          : 'false'
                      }
                    >
                      {inquiryDetailData !== null && inquiryDetailData.data.inquiryStatus === 'ANSWERED'
                        ? '답변완료'
                        : '답변대기'}
                    </ReplyRounded>
                    <span className='date'>
                      {inquiryDetailData !== null &&
                        (() => {
                          const date = new Date(inquiryDetailData.data.registerYmdt)
                          return format(date, 'yyyy. M. d')
                        })()}
                    </span>
                  </div>
                </div>
                {/* 문의내용, 사진 영역 */}
                <div className='contents_wrap'>
                  <div className='contents'>{inquiryDetailData !== null && inquiryDetailData.data.inquiryContent}</div>
                  {inquiryDetailData !== null && inquiryDetailData.data.originalImageUrls.length > 0 && (
                    <div className='inquiry_photo'>
                      {inquiryDetailData.data.originalImageUrls[0] && (
                        <a
                          href='#'
                          onClick={(e) => {
                            e.preventDefault()
                            handleImageClick(inquiryDetailData.data.originalImageUrls[0])
                          }}
                        >
                          <div
                            style={{
                              backgroundImage: `url(${inquiryDetailData.data.originalImageUrls[0]})`,
                            }}
                          ></div>
                        </a>
                      )}
                      {inquiryDetailData.data.originalImageUrls[1] && (
                        <a
                          href='#'
                          onClick={(e) => {
                            e.preventDefault()
                            handleImageClick(inquiryDetailData.data.originalImageUrls[1])
                          }}
                        >
                          <div
                            style={{
                              backgroundImage: `url(${inquiryDetailData.data.originalImageUrls[1]})`,
                            }}
                          ></div>
                        </a>
                      )}
                      {inquiryDetailData.data.originalImageUrls[2] && (
                        <a
                          href='#'
                          onClick={(e) => {
                            e.preventDefault()
                            handleImageClick(inquiryDetailData.data.originalImageUrls[2])
                          }}
                        >
                          <div
                            style={{
                              backgroundImage: `url(${inquiryDetailData.data.originalImageUrls[2]})`,
                            }}
                          ></div>
                        </a>
                      )}
                    </div>
                  )}
                </div>
              </div>

              {/* 구분선 */}
              <hr />

              {/* 관리자 답변 영역 */}
              <div className='inquiry_view'>
                {/* 담당자 답변내용이 있을 때 */}
                {inquiryDetailData?.data.answer ? (
                  <div className='admin_wrap'>
                    <div className='name_date'>
                      {/* inquiryDetailData.data.answer.answerNo으로 뭔가 알 수 있을 것 같은데 문의 해봐야할 듯 */}
                      <span className='name'>어바웃피싱 담당자</span>
                      <span className='date'>
                        {inquiryDetailData !== null &&
                          inquiryDetailData?.data.answer &&
                          (() => {
                            const date = new Date(inquiryDetailData?.data.answer.answerRegisterYmdt)
                            const year = date.getFullYear()
                            const month = date.getMonth() + 1
                            const day = date.getDate()
                            return `${year}.${month}.${day}`
                          })()}
                      </span>
                    </div>
                    <div
                      className='contents'
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(
                          inquiryDetailData !== null &&
                            inquiryDetailData?.data.answer &&
                            inquiryDetailData?.data.answer.answerContent
                        ),
                      }}
                    ></div>
                  </div>
                ) : null}
                {/* 담당자 답변내용이 없을 때 */}
                {inquiryDetailData !== null && !inquiryDetailData?.data.answer && (
                  <div className='empty_wrap'>
                    <img src={`${imgURL}/icon_admin_confirm.png`} alt='' />
                    현재 담당자가 문의 내용을 확인 중입니다.
                  </div>
                )}

                {/* 목록보기 버튼 */}
                <BtnWhiteRounded
                  className='btn_list'
                  onClick={() => {
                    if (isAppView) {
                      RNPostMessage(AFWebLinkType.goBack)
                    } else {
                      navigate(-1)
                    }
                  }}
                >
                  목록 보기
                </BtnWhiteRounded>
              </div>
            </div>
          </div>
        </div>
      </div>
      {selectedImageSrc && (
        <div className='selected_image'>
          <div className='dim'></div>
          <img src={selectedImageSrc} alt='Selected' />
          <button className='close_btn' type='button' onClick={togglePopup}>
            <img src='/images/icon_w_close.png' alt='' />
          </button>
        </div>
      )}
    </>
  )
}
